import { StyledFooter } from "./styles";


export default function Footer() {
  return (
    <StyledFooter>
    </StyledFooter>
  )
}
